module.exports = __webpack_public_path__ + "img/26.10e8aaf0.png";